import { useAuth0 } from '@auth0/auth0-react';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box,
    Grid,
    LinearProgress,
    Modal,
    styled,
    TextField,
    Typography,
    Paper,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import {
    addNetworkToSchool,
    fetchSchool,
    getSchoolTeachers,
} from '../../redux/SchoolSlice';
import NetworkInvite from './NetworkTeacherInvite';
import NetworkRequest from './NetworkRequest';
const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

const GeneralText = styled(TextField)(({ theme }) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: '0.5%',
    marginRight: '0.5%',
    width: '97%',
}));

export const Network = props => {
    const dispatch = useDispatch();
    const { getAccessTokenSilently } = useAuth0();
    const [createNetworkDisabled, setCreateNetworkDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [networkName, setNetworkName] = useState('');

    const school = useSelector(state => state.school.school.Data);
    const profile = useSelector(state => state.profile.profile.Data.Items[0]);
    console.log('--------------', school, profile);

    const changeNetworkName = event => {
        event.preventDefault();
        const network = event.target.value;
        setNetworkName(network);
        if (network.length > 3) {
            setCreateNetworkDisabled(false);
        } else {
            setCreateNetworkDisabled(true);
        }
    };

    const createNetwork = event => {
        setLoading(true);
        setCreateNetworkDisabled(true);

        async function addToSchool() {
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            const requestData = {
                'token': token,
                'request': { 'networkName': networkName },
            };
            const outcome = await dispatch(addNetworkToSchool(requestData));
            console.log('outcome', outcome);
            if (typeof outcome.error?.message !== 'undefined') {
                throw new Error('Failed to add network');
            }
        }
        addToSchool()
            .then(i => {
                props.setNotif('success', 3000, 'Added new network');
                setLoading(false);
            })
            .catch(err => {
                props.setNotif('error', 6000, 'Failed to add network');
                setLoading(false);
                setCreateNetworkDisabled(false);
            });
    };

    return (
        <Grid container xs={12}>
            <NetworkRequest profile={profile} />
        </Grid>
    );
};

export default Network;
